// extracted by mini-css-extract-plugin
export default {"root":"JGlYvocf","sideBanner":"tbATItpF","isLeft":"AJByhyFQ","isRight":"Mimt3OVT"};